import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import RoutesFile from "./RoutesFile";
import "./index.css";
import { ThemeProvider } from "./Context/ThemeContext";
import { DataProvider } from "./Context/DataContext";

const TRACKING_ID = "G-EPPRFZP16W"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <ThemeProvider>
    <DataProvider>
      <RoutesFile />
    </DataProvider>
  </ThemeProvider>,
  document.getElementById("root"),
);
